import { render } from "./MessageList.vue?vue&type=template&id=7218dcc5&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=7218dcc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7218dcc5"],['__file',"src/components/MessageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7218dcc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7218dcc5', __exports__)) {
    api.reload('7218dcc5', __exports__)
  }
  
  module.hot.accept("./MessageList.vue?vue&type=template&id=7218dcc5&scoped=true", () => {
    api.rerender('7218dcc5', render)
  })

}


export default __exports__